import React, { useState } from "react";
import { X } from "lucide-react";
import ParagraphTag from "../reusebale/Paragraph";
import LabelTag from "../reusebale/label";
import ButtonTag from "../reusebale/button";
import MyLoader from "../reusebale/myLoader";

const BankAccountPopup = ({ onClose, onSubmit, loading, prefillName }) => {
  const [form, setForm] = useState({
    holderName: prefillName || "",
    holderType: "CONSUMER",
    type: "CHECKING",
    accountNumber: "",
    routingNumber: "",
    wireRoutingNumber: "",
  });

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    onSubmit(form);
  };

  const isValid =
    form.holderName &&
    form.accountNumber &&
    form.routingNumber &&
    form.wireRoutingNumber;

  return (
    <main className="w-full h-screen backdrop-blur-sm bg-black/80 fixed inset-0 z-50 flex items-center justify-center">
      <section className="w-[90%] sm:w-[65%] md:w-[50%] lg:w-[40%] xl:w-[30%] bg-white shadow rounded-[24px] mx-auto p-6">
        <div className="flex justify-between items-center mb-4">
          <ParagraphTag
            content="Connect Bank Account"
            classes="text-darkColor font-popinsSemiBold text-base"
          />
          <button onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="mt-2">
          <LabelTag isStaric={false} name="Account Holder Name" classes="!text-xs !font-popinsMedium" />
          <input
            type="text"
            value={form.holderName}
            onChange={(e) => handleChange("holderName", e.target.value)}
            placeholder="Account holder name"
            className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-lg text-darkColor placeholder:text-zinc-700/50"
          />
        </div>

        <div className="mt-2">
          <LabelTag isStaric={false} name="Holder Type" classes="!text-xs !font-popinsMedium" />
          <select
            value={form.holderType}
            onChange={(e) => handleChange("holderType", e.target.value)}
            className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-lg text-darkColor"
          >
            <option value="CONSUMER">Consumer</option>
            <option value="CORPORATE">Corporate</option>
          </select>
        </div>

        <div className="mt-2">
          <LabelTag isStaric={false} name="Account Type" classes="!text-xs !font-popinsMedium" />
          <select
            value={form.type}
            onChange={(e) => handleChange("type", e.target.value)}
            className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-lg text-darkColor"
          >
            <option value="CHECKING">Checking</option>
            <option value="SAVINGS">Savings</option>
          </select>
        </div>

        <div className="mt-2">
          <LabelTag isStaric={false} name="Account Number" classes="!text-xs !font-popinsMedium" />
          <input
            type="text"
            value={form.accountNumber}
            onChange={(e) => handleChange("accountNumber", e.target.value)}
            placeholder="Enter account number"
            className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-lg text-darkColor placeholder:text-zinc-700/50"
          />
        </div>

        <div className="mt-2">
          <LabelTag isStaric={false} name="Routing Number" classes="!text-xs !font-popinsMedium" />
          <input
            type="text"
            value={form.routingNumber}
            onChange={(e) => handleChange("routingNumber", e.target.value)}
            placeholder="Enter routing number"
            className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-lg text-darkColor placeholder:text-zinc-700/50"
          />
        </div>

        <div className="mt-2">
          <LabelTag isStaric={false} name="Wire Routing Number" classes="!text-xs !font-popinsMedium" />
          <input
            type="text"
            value={form.wireRoutingNumber}
            onChange={(e) => handleChange("wireRoutingNumber", e.target.value)}
            placeholder="Enter wire routing number"
            className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-lg text-darkColor placeholder:text-zinc-700/50"
          />
        </div>

        <div className="w-full mt-6">
          {loading ? (
            <div className="flex justify-center items-center">
              <MyLoader />
            </div>
          ) : (
            <ButtonTag
              name="Connect Account"
              onSubmit={handleSubmit}
              disabled={!isValid}
              classes={`w-full text-base text-center border-2 border-themeColor ${
                isValid
                  ? "text-white bg-themeColor"
                  : "text-themeColor/40 border-themeColor/40 cursor-not-allowed"
              }`}
            />
          )}
        </div>
      </section>
    </main>
  );
};

export default BankAccountPopup;
